export default {
  computed: {
    startWidget() {
      const defaultDashboard = this.$store.getters['dashboards/dashboard'];
      const widgets = defaultDashboard.appDashboardsDashboardWidgets
        .map(dw => {
          return this.$store.getters['dashboardWidgets/widgets'][dw.dashboardWidgetId];
        });
      return widgets.find(w => w.widgetType === 'start');
    },
    startWidgetConfig() {
      return this.startWidget?.config;
    },
    startFlashcards() {
      return this.startWidgetConfig?.startFlashcards;
    },
    unansweredStartFlashcards() {
      if (!this.startFlashcards) {
        return [];
      }
      return this.startFlashcards.filter(flashcard => {
        const key = `${flashcard.flashcardId}-category-${flashcard.categoryId}`;
          return !this.$store.getters['flashcardStates/flashcardStates'][key];
      });
    },
  },
  methods: {
    gotoLearningPath() {
      const params = this.setLearningPathParams();
      this.$router.push({ name: 'learningPath#show', params });
    },
    setupLearningPath() {
      if (!this.unansweredStartFlashcards.length) {
        return;
      }
      this.$store.commit('learningPath/setFlashcards', [...this.unansweredStartFlashcards]);
      this.$store.commit('learningPath/setGroupingId', this.startWidgetConfig.groupingId);
      this.$store.commit('learningPath/setFallbackCategoryId', this.startWidgetConfig.startCategoryId);
    },
    setLearningPathParams() {
      if (!this.unansweredStartFlashcards.length) {
        return;
      }
      return {
        categoryId: this.unansweredStartFlashcards[0].categoryId,
        flashcardId: this.unansweredStartFlashcards[0].flashcardId,
      };
    },
  },
};
